module.exports = __webpack_public_path__ + "img/premium_slideimage02.9825a054.jpg";